module.exports = __webpack_public_path__ + "static/media/logoTransparent.367d80ee.png";